<template>
    <div class="ma-error-tooltip">
        <img
            ref="trigger"
            class="block w-6 h-6" src="/assets/images/shared/input--error@2x.png"
            @mouseover="visible = true"
            @mouseleave="visible = false"
        >
        <div
            ref="popper"
            v-show="visible"
            class="w-56 mx-2 py-3 px-5 shadow-md border bg-white z-10 text-ma-gray-3 text-sm font-medium"
        >
        {{ message }}
        </div>
    </div>
</template>

<script>
    import { createPopper }  from '@popperjs/core';
    export default {
        props: {
            message: {
                type: String,
                default: () => null
            }
        },
        data:() => {
            return {
                visible: false,
                popperInstance: null,
            }
        },
        watch: {
            visible(newVal) {
                if (newVal) {
                    // Popperjs sets translation property that takes tooltip off the screen.
                    // Due to that the whole screen shifts towards left creating a white
                    // background space to the right side. Setting initial translate value
                    // that keeps the tooltip inside the screen helps resolve this issue.
                    this.$refs.popper.style.transform = 'translate3d(-90%, 0px, 0px)';
                    this.popperInstance.update()
                }
            }
        },
        mounted() {
            this.popperInstance = createPopper(
                this.$refs.trigger,
                this.$refs.popper,
            )
        },
        
        beforeDestroy() {
            this.popperInstance.destroy()
        }
    }
</script>